import { render, staticRenderFns } from "./resourceLibrary.vue?vue&type=template&id=7045afbd"
import script from "./resourceLibrary.vue?vue&type=script&lang=js"
export * from "./resourceLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7045afbd')) {
      api.createRecord('7045afbd', component.options)
    } else {
      api.reload('7045afbd', component.options)
    }
    module.hot.accept("./resourceLibrary.vue?vue&type=template&id=7045afbd", function () {
      api.rerender('7045afbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/basic/resourceLibrary.vue"
export default component.exports